// global
import React, { Component } from 'react';
import { Popup, Image, Grid } from 'semantic-ui-react';
// local
// css
import './CylinderLabel.scss';
// image
import ic_flow_alert_gray from 'app/_assets/img/ic_flow_alert_gray.png';
// view
import PressureBar from './PressureBar';
// consts
import { CYLINDER_STATE } from 'salvus-shared/consts/cylinder';

const Content = () => {
    return (
        <Grid columns={2}>
            <Grid.Row>
                <Grid.Column id="level">
                    <div className="column-title">NÍVEL DO CILINDRO</div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.CURRENT} pressure={200} cylinderSize={4} /> Pressão Alta
                    </div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.CURRENT} pressure={115} cylinderSize={4} />Pressão Média
                    </div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.CURRENT} pressure={45} cylinderSize={4} /> Pressão Baixa
                    </div>
                </Grid.Column>
                <Grid.Column id="stock">
                    <div className="column-title">ESTOQUE</div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.FULL} />Cilindro Cheio
                    </div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.EMPTY} /> Cilindro Vazio
                    </div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.PENDING} /> Solicitação pendente
                    </div>
                    <div className="pressure-row">
                        <PressureBar state={CYLINDER_STATE.REQUESTED} /> Solicitação agendada
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

class CylinderLabel extends Component {
    render() {
        return (
            <Popup id="popup-cylinder-legend" trigger={<Image id="popup-cylinder-legend-trigger" src={ic_flow_alert_gray} />} content={<Content />} flowing />
        );
    }
}

export default CylinderLabel;
